import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Navigate } from "react-router-dom";
const ProtectedRoute = ({ children }) => {
  const { isLogged } = useContext(AuthContext);
  if (!isLogged) {
    return <Navigate to="/connexion" replace />;
  }
  return children;
};

export default ProtectedRoute;
